var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit, EventEmitter, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { map, takeWhile, debounceTime, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import { combineLatest, fromEvent } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as moment from 'moment';
import { NavigationStart, Router } from '@angular/router';
import * as BookingStepActions from '@ibe/store/actions/booking-steps.actions';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { EVENT_ACTION_ADD_CART, EVENT_ACTION_CLICK, INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { DEFAULT_LANGUAGE, DISCOUNT_STATUS_ACTIVE, EQUIPMENT_CODE_BUS, SESSION_VAR_KEY_CURRENCY, TRIP_TYPE_MULTICITY_CODE, TRIP_TYPE_ONE_WAY, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_ROUND_TRIP_CODE } from '@ibe.config';
import { BookingService } from '@ibe.services/booking.tap.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { ConfirmDialogService, ModalService, SidebarService, ScreenService } from '@ibe/services/ui';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
var INDRAStepsFooterComponent = /** @class */ (function () {
    function INDRAStepsFooterComponent(store, sidebarService, bookingService, router, bookingSearchService, googleAnalytics, currencyService, bfmStorage, paymentService, flightPriceService, ibeAdminConfigService, dateService, confirmDialogService, parallelService, ibeAdminService, modalService, screenService, milesService) {
        var _this = this;
        this.store = store;
        this.sidebarService = sidebarService;
        this.bookingService = bookingService;
        this.router = router;
        this.bookingSearchService = bookingSearchService;
        this.googleAnalytics = googleAnalytics;
        this.currencyService = currencyService;
        this.bfmStorage = bfmStorage;
        this.paymentService = paymentService;
        this.flightPriceService = flightPriceService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.dateService = dateService;
        this.confirmDialogService = confirmDialogService;
        this.parallelService = parallelService;
        this.ibeAdminService = ibeAdminService;
        this.modalService = modalService;
        this.screenService = screenService;
        this.milesService = milesService;
        this.showDialog = true;
        this.handleTTT = new EventEmitter();
        this.brandSelected = new EventEmitter();
        this.selectPack = new EventEmitter();
        this.outputSelectedStopoverFlight = new EventEmitter();
        this.outputSelectedMulticityFlight = new EventEmitter();
        this.confirmPassengersAndContacts = new EventEmitter();
        // ==================================== from payment ==============================================================================================================================================================
        this.isNonZeroPaymentMethod = false;
        this.isAdyenMethod = false;
        this.isPaybyrdMethod = false;
        this.isZeroPaymentMethod = false;
        this.formIsValid = false;
        this.isButtonPaymentDisableOverride = false;
        this.isPaypalPaymentMethod = false;
        this.confirmPayment = new EventEmitter();
        this.adyenCheckOut = new EventEmitter();
        this.paybyrdCheckOut = new EventEmitter();
        this.confirmZeroPayment = new EventEmitter();
        this.confirmTTTPayment = new EventEmitter();
        // Handle scrolls on review-your-trip page
        this.toContinue = false;
        this.nextLabel = this.INDRA_getTranslation('footer.text.continue');
        this.handleAction = new EventEmitter();
        this.disabledContinue = false;
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.flightInformation$ = this.store.select(fromStore.getFlightInformation);
        this.flightOutboundInformation$ = this.store.select(fromStore.getOutboundFlightInformation);
        this.flightInboundInformation$ = this.store.select(fromStore.getInboundFlightInformation);
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.hasChanges$ = combineLatest([this.bookAwardFlights$,
            this.bookedTrip$]);
        this.userInfo$ = this.store.select(fromStore.getUserInfo);
        this.booking_steps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.current_page$ = this.store.select(fromStore.getSelectedBookingCurrentPage);
        this.current_step$ = this.store.select(fromStore.getSelectedBookingCurrentStep);
        this.current_step = 0;
        this.paymentStatus$ = this.bookingService.paymentStatus;
        this.viewToShow$ = this.store.select(fromStore.getOptionsBarViewToShow);
        this.isTTT$ = this.store.select(fromStore.getSelectedBookedTripTimeToThink);
        this.isTTT = false;
        this.isScreenMobileTabletPortrait$ = this.store.select(fromStore.isScreenMobileTabletPortrait);
        this.booking_type$ = this.store.select(fromStore.getSelectedBookingType);
        this.timeToThink_to_booking$ = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
        this.timeToThink_to_booking = false;
        this.bookedTripDiscounts$ = this.store.select(fromStore.getSelectedBookedTripDiscounts);
        this.bookedTripDiscounts = [];
        this.milesInFlightDiscount$ = this.store.select(fromStore.getMilesInFlightDiscount);
        this.promoCodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.promoCodesAndVoucher = [];
        this.loading$ = this.store.select(fromStore.getAncillaryToPayWithMilesLoading);
        this.weakFlightsDiscount$ = this.store.select(fromStore.getWeakFlightAmt);
        this.discountMiles$ = this.store.select(fromStore.getMilesBarDiscount);
        this.discountMiles = 0;
        this.stopover$ = this.store.select(fromStore.getMiniIBEStopovers);
        this.isPassengerCreated$ = this.parallelService.isPassengerCreated$;
        this.isContactCreated$ = this.parallelService.isContactCreated$;
        this.areCheckboxesCompleted$ = this.parallelService.areCheckboxesCompleted$;
        this.allSubscriptions = [];
        this.allSubs = [];
        this.steps = [];
        this.multi_flights = [];
        this.stopoverFlights = [];
        this.isChanging = true;
        this.isDisabled = false;
        this.showDeparture = false;
        this.showDepartureDetails = false;
        this.showReturn = false;
        this.showReturnDetails = false;
        this.retDetails = Object.assign({}, { bound: 'bound', date: 'date' });
        this.depDetails = Object.assign({}, { bound: 'bound', date: 'date' });
        this.passengers_label = '';
        this.isAlive = true;
        this.isMobile = false;
        this.state = 'collapsed';
        this.isCorporate = false;
        this.isPNRCreated = false;
        this.showFooter = true;
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (user) {
            _this.isUserLoggedIn = user;
            _this.userMiles = user && user['currentPoints'] ? user['currentPoints'] : 0;
            if (user) {
                _this.userTierLevel = user.ffLevel;
                _this.userMiles = user.currentPoints;
            }
            else {
                _this.userTierLevel = null;
                _this.userMiles = null;
            }
        });
        // get booking total price object 
        this.paymentService.totalFlightPrice
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (totalFlightPrice) {
            _this.totalFlightPrice = totalFlightPrice;
        });
        this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        this.bookedTripDiscounts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discounts) {
            _this.bookedTripDiscounts = Object.assign([], discounts);
        });
        this.weakFlightsDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value != null) {
                _this.weakFlightsDiscount = value;
            }
            else {
                _this.weakFlightsDiscount = [];
            }
        });
        this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.milesInFlightDiscount = value;
        });
        this.promoCodesAndVoucher$
            .pipe(takeWhile(function () { return _this.isAlive; }), map(function (value) { return value && value.filter(function (discount) { return discount.status === DISCOUNT_STATUS_ACTIVE; }); }))
            .subscribe(function (discount) {
            if (discount && discount.length > 0) {
                _this.promoCodesAndVoucher = discount;
            }
            else {
                _this.promoCodesAndVoucher = [];
            }
        });
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var bookAwardFlights = _a[0], bookedTrip = _a[1];
            _this.bookAwardFlights = bookAwardFlights;
            if (bookedTrip) {
                _this.bookedTrip = bookedTrip;
                _this.trip_pnr = bookedTrip.pnr;
                _this.passengers_label = bookedTrip.passengerCount.toString() + ' ' + _this.INDRA_getTranslation('footer.text.passengers');
                _this.INDRA_getTotalPrice();
                if (_this.bookedTrip.flights.length > 0) {
                    _this.selectedFlight = null;
                }
            }
            if (_this.current_page === 'flights') {
                if ((_this.flightInformation && _this.flightInformation.flight === null) || (_this.flightOutboundInformation && _this.flightOutboundInformation.flight === null)) {
                    _this.selectedFlight = null;
                    _this.selectedMultiFlights = null;
                    _this.selectedStopoverFlights = null;
                }
            }
        });
        this.discountMiles$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discountMiles) { return _this.discountMiles = discountMiles; });
        this.current_step$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.current_step = value;
        });
        this.booking_type$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.booking_type = value;
        });
        this.current_page$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.current_page = value;
            if (value != 'dates' && value != 'flights')
                _this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
        });
        this.booking_steps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookingSteps = value;
            _this.INDRA_setUpSections();
            _this.INDRA_setUpButton();
            _this.INDRA_handleBrandSelection();
            _this.INDRA_updateDescription();
        });
        this.loading$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.loading = value;
            if (_this.loading) {
                _this.isChanging = false;
            }
        });
        this.timeToThink_to_booking$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.timeToThink_to_booking = true;
            }
        });
        this.isScreenMobileTabletPortrait$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        this.isTTT$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isTTT = value;
        });
        this.bookingService.paymentStatus
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe({
            next: function (status) {
                _this.isDisabled = !status;
            },
            error: function (err) { },
            complete: function () { }
        });
        this.paymentService.totalFlightPrice
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (totalFlightPrice) {
            _this.totalFlightPrice = totalFlightPrice;
        });
        this.paymentService.updateBookingTotals
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (update) {
            if (update) {
                _this.INDRA_updateBookingTotals();
            }
        });
        this.stopover$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.is_stopover = false;
            if (value.length > 0) {
                _this.is_stopover = true;
                _this.stopover = value[0];
                if (_this.router.url.includes('flights-stopover') && _this.stopover) {
                    _this.INDRA_setUpButton();
                }
            }
        });
        this.bfmStorage.timeToThinkCode
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (code) {
            if (code) {
                _this.selectedTimeToThinkCode = code;
                _this.timeToThinkResponse = _this.bfmStorage.INDRA_getTimeToThink();
            }
        });
        this.flightInformation$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.flightInformation = value;
                _this.INDRA_handleBrandSelection();
            }
        });
        this.flightInboundInformation$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.flightInboundInformation = value;
            }
        });
        this.resize$ = fromEvent(window, 'resize')
            .pipe(debounceTime(250), map(function () { return window.innerWidth; }), distinctUntilChanged(), startWith(window.innerWidth), tap(function (width) {
            _this.screenService.setWindowWidth(Number(width));
        }));
        this.resize$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe();
    }
    ;
    ;
    ;
    INDRAStepsFooterComponent.prototype.ngOnChanges = function (changes) {
        if (changes.disabledContinue) {
            this.disabledContinue = changes.disabledContinue.currentValue;
            if (this.disabledContinue) {
                this.btnText = this.INDRA_getTranslation('footer.text.scrollDown');
            }
            else {
                this.btnText = this.nextLabel;
            }
        }
    };
    INDRAStepsFooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routerSubscription = this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
                if (_this.current_page === 'flights') {
                    if (_this.flightInformation && (_this.flightInformation.stage === 'stopover' || _this.flightInformation.stage === 'multicity')) {
                        if ((_this.flightInformation && _this.flightInformation.flight === null) || (_this.flightOutboundInformation && _this.flightOutboundInformation.flight === null)) {
                            _this.selectedMultiFlights = null;
                            _this.selectedStopoverFlights = null;
                            _this.brandSelected.emit(false);
                        }
                    }
                    else {
                        if ((_this.flightInformation && _this.flightInformation.flight === null) || (_this.flightOutboundInformation && _this.flightOutboundInformation.flight === null)) {
                            _this.selectedFlight = null;
                            _this.brandSelected.emit(false);
                        }
                    }
                }
            }
        });
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
        this.totalPrice = this.totalPrice ? this.totalPrice : this.currency === 'EUR' ? '0,00' : '0.00';
        var combinedSubscription = combineLatest([
            this.isPassengerCreated$,
            this.isContactCreated$,
            this.areCheckboxesCompleted$,
        ]).pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var isPassengerCreated = _a[0], isContactCreated = _a[1], areCheckboxesCompleted = _a[2];
            if (_this.current_page === 'payment') {
                _this.isDisabled = _this.isPNRCreated || !(isPassengerCreated && isContactCreated && areCheckboxesCompleted);
                _this.isPassengerCreated = isPassengerCreated;
                _this.isContactCreated = isContactCreated;
            }
        });
        this.allSubs.push(combinedSubscription);
        // This is a call to generate api when going to review your trip page in order to 
        // always get the latest total price especially when there are ancillaries added.
        if (this.router.url.includes('review-your-trip')) {
            this.INDRA_updateBookingTotals();
        }
        // Added a condition when totalFlightPrice is empty when in payment page
        // Usually happens on page refresh in payment page when redirected somewhere for payment
        // It will load translations first and call generate api
        if (!this.totalFlightPrice && this.router.url.includes('booking/payment')) {
            this.INDRA_loadTranslations();
            this.INDRA_updateBookingTotals();
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_handleBrandSelection = function () {
        var _this = this;
        if (this.booking_type !== TRIP_TYPE_MULTICITY_CODE) {
            if (this.flightInformation && this.flightInformation.stage === 'stopover') {
                this.is_stopover = true;
                // this.selectedMultiFlights = this.flightInformation.flight.flights;
                this.selectedStopoverFlights = this.flightInformation.flight.flights;
                this.outputSelectedStopoverFlight.emit(this.selectedStopoverFlights);
                this.INDRA_setUpSections();
                this.INDRA_updateDescription();
                this.INDRA_setUpButton();
                this.showDepartureDetails = !this.isMobile;
                this.totalPrice = this.INDRA_formatCash(this.selectedStopoverFlights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0));
                this.isDisabled = false;
            }
            else if (this.flightInformation && this.flightInformation.stage === 'flights') {
                this.selectedFlight = this.flightInformation.flight.flight;
                this.selectedDate = this.flightInformation.flight.time;
                this.showDepartureDetails = true;
                this.INDRA_updateDescription();
                if (this.bookingSteps[0] && this.bookingSteps[1] && this.bookingSteps[0].flight_selected && this.bookingSteps[1].flight_selected) {
                    this.isDisabled = false;
                }
            }
            else {
                this.flightOutboundInformation$
                    .pipe(takeWhile(function () { return _this.isAlive; }))
                    .subscribe(function (value) {
                    if (value) {
                        _this.flightOutboundInformation = value;
                        if (_this.flightOutboundInformation.flight) {
                            _this.selectedFlight = _this.flightOutboundInformation.flight.flight;
                            _this.selectedDate = _this.flightOutboundInformation.flight.time;
                            _this.showDepartureDetails = true;
                            _this.INDRA_updateDescription();
                        }
                    }
                });
            }
        }
        else {
            if (this.flightInformation && this.flightInformation.stage === 'stopover') {
                this.is_stopover = true;
                this.selectedStopoverFlights = this.flightInformation.flight.flights;
                this.outputSelectedStopoverFlight.emit(this.selectedStopoverFlights);
                this.INDRA_setUpSections();
                this.INDRA_updateDescription();
                this.INDRA_setUpButton();
                this.showDepartureDetails = !this.isMobile;
                this.totalPrice = this.INDRA_formatCash(this.selectedStopoverFlights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0));
                this.isDisabled = false;
            }
            else if (this.flightInformation && this.flightInformation.stage === 'multicity') {
                this.selectedMultiFlights = this.flightInformation.flight.flights;
                this.INDRA_updateDescription();
                this.showDepartureDetails = !this.isMobile;
                this.totalPrice = this.INDRA_formatCash(this.selectedMultiFlights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0));
                this.isDisabled = false;
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_setFlightDetails = function (flight, date) {
        var segments = flight.listSegment;
        var departureAirport = segments[0].departureAirport;
        var arrivalAirport = segments.length > 1 ? segments[segments.length - 1].arrivalAirport : segments[0].arrivalAirport;
        return this.INDRA_setDetails(departureAirport, arrivalAirport, date);
    };
    INDRAStepsFooterComponent.prototype.INDRA_setMultiFlightDetails = function (flights) {
        this.multi_flights = [];
        var counter = 1;
        for (var i = 0; i < flights.length; i++) {
            var currentFlight = flights[i];
            var stopover = currentFlight.stopover !== undefined;
            var depAirport = currentFlight.listSegment[0].departureAirport;
            var arrAirport = stopover ? flights[i + 1].listSegment[0].arrivalAirport : currentFlight.listSegment[currentFlight.listSegment.length - 1].arrivalAirport;
            var label = counter + " - " + this.INDRA_getBound(depAirport, arrAirport);
            var stops = currentFlight.stops ? currentFlight.stops.length + " Stop" : null;
            if (stopover)
                i++; // Skip next flight if stopover exists
            this.multi_flights.push({ label: label, stopover: stopover, stops: stops });
            counter++;
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_setStopoverDetails = function (flights, stopoverWhen) {
        if (this.is_stopover) {
            if (flights && flights.length > 0) {
                var stopIndex = flights.findIndex(function (f) { return f.stopover; });
                var segment = flights[0].listSegment[0];
                var depAirport = segment.departureAirport;
                var arrAirport = segment.arrivalAirport;
                if (stopoverWhen == 'outbound')
                    arrAirport = flights[stopIndex + 1].listSegment[0].arrivalAirport;
                if (stopoverWhen == 'inbound')
                    arrAirport = flights[stopIndex].listSegment[0].departureAirport;
                this.depDetails = this.INDRA_setDetails(depAirport, arrAirport, segment.departureDate);
                if (this.booking_type === TRIP_TYPE_ONE_WAY) {
                    var arrivalAirport = flights[stopIndex + 1].listSegment[flights[stopIndex + 1].listSegment.length - 1].arrivalAirport;
                    return this.INDRA_setDetails(depAirport, arrivalAirport, flights[0].departureDate);
                }
                if (this.booking_type == TRIP_TYPE_ROUND_TRIP_CODE) {
                    var dateInbound = this.stopover.when == 'outbound'
                        ? flights[flights.length - 1].listSegment[0].departureDate
                        : flights[stopIndex].listSegment[0].departureDate;
                    this.retDetails = this.INDRA_setDetails(arrAirport, depAirport, dateInbound);
                    this.showReturn = true;
                    this.showReturnDetails = true;
                }
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_setOneWayFlightDetails = function (flight, date, isOutbound) {
        var segment = flight.listSegment;
        var departureAirport = segment[0].departureAirport;
        var arrivalAirport = segment[isOutbound && segment.length > 1 ? segment.length - 1 : 0].arrivalAirport;
        return this.INDRA_setDetails(departureAirport, arrivalAirport, date);
    };
    INDRAStepsFooterComponent.prototype.INDRA_updateDescription = function () {
        switch (this.current_page) {
            case 'dates':
                break;
            case 'flights':
                if (this.booking_type === TRIP_TYPE_MULTICITY_CODE && this.selectedMultiFlights) {
                    this.INDRA_setMultiFlightDetails(this.selectedMultiFlights);
                }
                else if (this.is_stopover && this.selectedStopoverFlights && this.selectedStopoverFlights.length > 0) {
                    this.INDRA_setStopoverDetails(this.selectedStopoverFlights, this.stopover.when);
                }
                else if (this.selectedFlight) {
                    if (!this.bookingSteps[0].flight_selected && this.selectedFlight.bound === 'outbound') {
                        this.isDisabled = false;
                        this.depDetails = this.INDRA_setFlightDetails(this.selectedFlight, this.selectedDate);
                    }
                    else if (this.bookedTrip.flights.length > 0) {
                        this.depDetails = this.INDRA_setFlightDetails(this.bookedTrip.flights[0], this.bookingSteps[0].date);
                    }
                    if (this.selectedFlight.bound === 'inbound') {
                        this.retDetails = this.INDRA_setFlightDetails(this.selectedFlight, this.selectedDate);
                        this.showReturn = this.showReturnDetails = true;
                        this.isDisabled = false;
                    }
                }
                break;
            default:
                if (this.bookedTrip && this.bookedTrip.flights && this.bookedTrip.flights.length > 0) {
                    if (this.booking_type !== TRIP_TYPE_MULTICITY_CODE) {
                        if (this.is_stopover) {
                            var stopIndex = this.bookedTrip.flights.findIndex(function (f) { return f.stopover != undefined; });
                            var segment = this.bookedTrip.flights[0].listSegment[0];
                            var depAirport = segment.departureAirport;
                            var arrAirport = segment.arrivalAirport;
                            if (this.stopover.when == 'outbound')
                                arrAirport = this.bookedTrip.flights[stopIndex + 1].listSegment[0].arrivalAirport;
                            if (this.stopover.when == 'inbound')
                                arrAirport = this.bookedTrip.flights[stopIndex].listSegment[0].departureAirport;
                            this.depDetails = this.INDRA_setDetails(depAirport, arrAirport, segment.departureDate);
                            if (this.booking_type == TRIP_TYPE_ROUND_TRIP_CODE) {
                                var dateInbound = this.stopover.when == 'outbound'
                                    ? this.bookedTrip.flights[this.bookedTrip.flights.length - 1].listSegment[0].departureDate
                                    : this.bookedTrip.flights[stopIndex].listSegment[0].departureDate;
                                this.retDetails = this.INDRA_setDetails(arrAirport, depAirport, dateInbound);
                                this.showReturn = true;
                                this.showReturnDetails = true;
                            }
                        }
                        else {
                            if (this.bookedTrip.flights.length > 0) {
                                var outboundFlight = this.bookedTrip.flights[0];
                                this.depDetails = this.INDRA_setOneWayFlightDetails(outboundFlight, this.bookingSteps[0].date, outboundFlight.bound === 'outbound');
                                if (this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE && this.bookedTrip.flights[1]) {
                                    var inboundFlight = this.bookedTrip.flights[1];
                                    this.retDetails = this.INDRA_setOneWayFlightDetails(inboundFlight, this.bookingSteps[this.bookingSteps.length - 1].date, inboundFlight.bound === 'inbound');
                                }
                            }
                        }
                    }
                    else {
                        this.INDRA_setMultiFlightDetails(this.bookedTrip.flights);
                    }
                }
        }
        this.showReturnDetails = this.retDetails && this.retDetails.bound !== 'bound';
    };
    INDRAStepsFooterComponent.prototype.INDRA_setDetails = function (departure, arrival, date) {
        if (date === void 0) { date = null; }
        var bound = departure + ' - ' + arrival;
        var dateTime = null;
        if (date) {
            date = typeof date === 'string'
                ? new Date(this.dateService.INDRA_formatDate(date, 'MM/DD/YYYY HH:mm'))
                : date;
            dateTime = this.INDRA_getTime(date);
        }
        // if (this.isMobile) {
        // return Object.assign({}, { bound: bound + ' | ' + dateTime, date: dateTime });
        // }
        return Object.assign({}, { bound: bound, date: dateTime });
    };
    INDRAStepsFooterComponent.prototype.INDRA_getBound = function (dep, arr) {
        return dep + ' - ' + arr;
    };
    INDRAStepsFooterComponent.prototype.INDRA_getTime = function (date) {
        var dateOptions = {
            weekday: 'short',
            day: '2-digit',
            month: 'short'
        };
        var intDateFormat = new Intl.DateTimeFormat("en-us", dateOptions);
        var formattedDate = intDateFormat.format(date);
        var hours = date.getHours().toString().padStart(2, '0') + 'h';
        var minutes = date.getMinutes().toString().padStart(2, '0');
        return formattedDate + ' | ' + hours + minutes;
    };
    INDRAStepsFooterComponent.prototype.INDRA_setUpSections = function () {
        switch (this.current_page) {
            case 'dates': {
                this.showDeparture = this.bookingService.allDatesSelected();
                this.showDepartureDetails = false;
                this.showReturn = false;
                break;
            }
            case 'flights': {
                this.showDeparture = true;
                this.showDepartureDetails = this.bookingSteps[0].flight_selected;
                this.showReturn = this.booking_type == TRIP_TYPE_ROUND_TRIP_CODE && this.bookingSteps[0].flight_selected;
                break;
            }
            default: {
                this.showDeparture = true;
                this.showReturn = this.booking_type == TRIP_TYPE_ROUND_TRIP_CODE && !this.bookedTrip.stopover;
                this.showReturnDetails = true;
                this.showDepartureDetails = true;
                break;
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_handlePriceBreakDown = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isTTT && !this.timeToThink_to_booking)
                    this.sidebarService.openSidebar(['price-breakdown-ttt']);
                else if (this.current_page === 'flights') {
                    this.sidebarService.openSidebar(['booking-price-breakdown']);
                }
                else
                    this.sidebarService.openSidebar(['booking-price-breakdown-new']);
                return [2 /*return*/];
            });
        });
    };
    INDRAStepsFooterComponent.prototype.INDRA_getDepartureTitle = function () {
        var title = this.INDRA_getTranslation('footer.text.selectDeparture'); //'Select Departure';
        if (this.booking_type === TRIP_TYPE_MULTICITY_CODE) {
            if (this.multi_flights.length > 0) {
                title = this.INDRA_getTranslation('footer.text.flights'); //Flights'; 
            }
            else {
                title = this.INDRA_getTranslation('footer.text.selectFlights'); //'Select Flights';
            }
        }
        else {
            title = this.INDRA_getTranslation('footer.text.selectDeparture'); //'Select Departure';
            if (this.bookedTrip && (this.bookedTrip.flights[0] || this.selectedFlight || this.selectedStopoverFlights || this.selectedMultiFlights))
                title = this.INDRA_getTranslation('footer.text.departure'); //'Departure';
        }
        return title;
    };
    INDRAStepsFooterComponent.prototype.INDRA_getReturnTitle = function () {
        return this.selectedStopoverFlights || (this.selectedFlight && this.selectedFlight.bound === 'inbound')
            ? this.INDRA_getTranslation('footer.text.return')
            : this.INDRA_getTranslation('footer.text.selectReturn');
    };
    INDRAStepsFooterComponent.prototype.INDRA_setUpButton = function () {
        switch (this.current_page) {
            case 'dates': {
                this.isDisabled = !this.bookingService.allDatesSelected();
                this.showFooter = !this.isDisabled;
                this.btnText = this.INDRA_getTranslation('footer.text.confirmDates'); //'Confirm Dates';
                break;
            }
            case 'flights': {
                this.isDisabled = true;
                if (this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
                    if (this.bookingSteps[0] && this.bookingSteps[1] && this.bookingSteps[0].flight_selected && this.bookingSteps[1].flight_selected) {
                        this.isDisabled = false;
                    }
                    if (this.bookingSteps[0].flight_selected) {
                        this.btnText = this.INDRA_getTranslation('footer.text.continueToExtras'); //'Continue to Review';
                    }
                    else {
                        if (this.stopover) {
                            this.btnText = this.INDRA_getTranslation('footer.text.continueToExtras'); //'Continue to Review';
                        }
                        else {
                            this.btnText = this.INDRA_getTranslation('footer.text.selectReturn'); //'Select Return';
                        }
                    }
                }
                else {
                    if (this.bookingSteps[0] && this.bookingSteps[0].flight_selected) {
                        this.isDisabled = false;
                    }
                    this.btnText = this.INDRA_getTranslation('footer.text.continueToReview');
                }
                break;
            }
            case 'review': {
                this.isDisabled = false;
                this.btnText = this.nextLabel; //'Continue to Extras';
                break;
            }
            case 'extras': {
                this.isDisabled = false;
                this.btnText = this.INDRA_getTranslation('footer.text.continueToPayment'); //'Continue to Payment';
                break;
            }
            case 'payment': {
                this.isDisabled = true;
                this.btnText = this.INDRA_getTranslation('footer.text.continueToPayment'); //'Continue to Payment';
                break;
            }
            default: {
                this.isDisabled = false;
                this.btnText = this.INDRA_getTranslation('footer.text.continueToPayment'); //'Continue to Payment';
                break;
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_getBookType = function () {
        var type = '';
        switch (this.booking_type) {
            case TRIP_TYPE_ROUND_TRIP_CODE: {
                type = this.INDRA_getTranslation('footer.text.roundTrip'); //'Round trip';
                break;
            }
            case TRIP_TYPE_ONE_WAY_CODE: {
                type = this.INDRA_getTranslation('footer.text.oneWay'); //'One way';
                break;
            }
            case TRIP_TYPE_MULTICITY_CODE: {
                type = this.INDRA_getTranslation('footer.text.multicity'); //'Multicity';
                break;
            }
        }
        return type;
    };
    INDRAStepsFooterComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubs; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_formatCash = function (value) {
        return value.toLocaleString(DEFAULT_LANGUAGE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    /**
     * Return if booking is roundtrip
     */
    INDRAStepsFooterComponent.prototype.INDRA_isRoundTrip = function () {
        return this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE;
    };
    /**
     * Returns the date in the format day month
     *
     * @param {*} index
     * @returns {string}
     * @memberof INDRADatesPageComponent
     */
    INDRAStepsFooterComponent.prototype.INDRA_printDate = function (index) {
        var date = this.steps[index].date;
        return moment(date).format('DD MMM');
    };
    INDRAStepsFooterComponent.prototype.INDRA_printTime = function (index) {
        return this.steps[index].time;
    };
    /**
 * Clear selected dates
 */
    INDRAStepsFooterComponent.prototype.INDRA_clearDates = function () {
        this.bookingService.TAP_clearDates();
    };
    INDRAStepsFooterComponent.prototype.INDRA_handleAction = function () {
        var _this = this;
        switch (this.current_page) {
            case 'dates': {
                this.INDRA_registerGASelectDates();
                this.bookingService.goToNextRoute();
                // this.bookingService.goToNextStep();
                break;
            }
            case 'flights': {
                if (this.booking_type !== TRIP_TYPE_MULTICITY_CODE) {
                    if (this.is_stopover) {
                        this.selectedStopoverFlights.forEach(function (flight, idx) {
                            if (flight) {
                                var departureDateTime = new Date(_this.dateService.INDRA_formatDate(flight.listSegment[0].departureDate, 'MM/DD/YYYY HH:mm'));
                                _this.bookingSearchService.setFlight(flight, departureDateTime, idx);
                            }
                        });
                        this.selectPack.emit({ selectPack: true });
                        if (this.selectedStopoverFlights.length > 0) {
                            this.INDRA_callBookingFare(this.selectedStopoverFlights);
                        }
                        else {
                            this.confirmDialogService.openConfirmDialog();
                        }
                    }
                    else {
                        this.bookingSearchService.setFlight(this.selectedFlight, this.selectedDate);
                        this.brandSelected.emit(this.bookingService.isLastStep());
                    }
                    if (this.bookingService.allFlightsSelected()) {
                        this.INDRA_handleTTT();
                    }
                }
                else {
                    if (this.is_stopover) {
                        this.selectedStopoverFlights.forEach(function (flight, idx) {
                            if (flight) {
                                var departureDateTime = new Date(_this.dateService.INDRA_formatDate(flight.listSegment[0].departureDate, 'MM/DD/YYYY HH:mm'));
                                _this.bookingSearchService.setFlight(flight, departureDateTime, idx);
                            }
                        });
                        this.selectPack.emit({ selectPack: true });
                        if (this.selectedStopoverFlights.length > 0) {
                            this.INDRA_callBookingFare(this.selectedStopoverFlights);
                        }
                        else {
                            this.confirmDialogService.openConfirmDialog();
                        }
                        // for award flights, if user has enough miles to cover the flight cost, proceed to call booking fare
                        if (this.bookingService.allFlightsSelected() && this.bookAwardFlights) {
                            var milesPrice = this.selectedStopoverFlights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0);
                            var hasEnoughMiles = this.bookingSearchService.INDRA_checkIfEnoughMilesForFlight(milesPrice, this.userMiles, this.userTierLevel);
                            if (hasEnoughMiles) {
                                this.INDRA_callBookingFare(this.selectedStopoverFlights);
                            }
                        }
                    }
                    else {
                        var flightsFilter = this.selectedMultiFlights.filter(function (cur) { return cur.type != 'stopover'; });
                        for (var idx in flightsFilter) {
                            var flight = flightsFilter[idx];
                            var departureDateTime = new Date(this.dateService.INDRA_formatDate(flight.listSegment[0].departureDate, 'MM/DD/YYYY HH:mm'));
                            this.bookingSearchService.setFlight(flight, departureDateTime, idx);
                        }
                        //CODE BEFORE Navigation Footer (to be placed there)...
                        this.selectPack.emit({ selectPack: true, milesGoDiscount: this.selectedMultiFlights.milesGoDiscount });
                        this.confirmDialogService.openConfirmDialog();
                        // for award flights, if user has enough miles to cover the flight cost, proceed to call booking fare
                        if (this.bookingService.allFlightsSelected() && this.bookAwardFlights) {
                            var milesPrice = this.selectedMultiFlights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0);
                            var hasEnoughMiles = this.bookingSearchService.INDRA_checkIfEnoughMilesForFlight(milesPrice, this.userMiles, this.userTierLevel);
                            if (hasEnoughMiles) {
                                this.INDRA_callBookingFare(this.selectedMultiFlights);
                            }
                        }
                    }
                }
                break;
            }
            case 'review': {
                if (this.toContinue) {
                    if (this.is_stopover || this.booking_type === TRIP_TYPE_MULTICITY_CODE) {
                        this.router.navigate(['/booking/payment']);
                    }
                    else {
                        this.router.navigate(['/booking/extras-to-your-trip']);
                    }
                }
                else {
                    this.handleAction.emit();
                }
                break;
            }
            case 'extras': {
                this.router.navigate(['/booking/payment']);
                break;
            }
            case 'timeToThink': {
                this.confirmTTTPayment.emit(true);
            }
            case 'payment': {
                if (this.isPassengerCreated && this.isContactCreated) {
                    this.isPassengerCreated = false;
                    this.isContactCreated = false;
                    this.isDisabled = true;
                    if (!this.isPNRCreated) {
                        this.isPNRCreated = true;
                        this.confirmPassengersAndContacts.emit(true);
                    }
                    this.btnText = this.INDRA_getTranslation('footer.text.confirmBookingAndPay'); //'Confirm booking and pay';
                }
                if (this.isNonZeroPaymentMethod) {
                    this.confirmPayment.emit(true);
                }
                else if (this.isAdyenMethod) {
                    this.adyenCheckOut.emit(true);
                }
                else if (this.isPaybyrdMethod) {
                    this.paybyrdCheckOut.emit(true);
                }
                else if (this.isZeroPaymentMethod) {
                    this.confirmZeroPayment.emit(true);
                }
                break;
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_hasBusTrip = function (flights) {
        return this.bookingSearchService.INDRA_hasNonAirplaneSegment(flights, EQUIPMENT_CODE_BUS);
    };
    INDRAStepsFooterComponent.prototype.INDRA_handleTTT = function () {
        this.handleTTT.emit(true);
    };
    INDRAStepsFooterComponent.prototype.INDRA_editSearch = function () {
        this.sidebarService.openSidebar([
            'edit-search',
        ]);
    };
    INDRAStepsFooterComponent.prototype.INDRA_handleToggle = function () {
        this.state = this.state === 'expanded' ? 'collapsed' : 'expanded';
    };
    INDRAStepsFooterComponent.prototype.INDRA_getDepBoxClasses = function () {
        return {
            'visible': this.showDeparture,
            'invisible': !this.showDeparture,
            'multi-col3': this.booking_type == TRIP_TYPE_MULTICITY_CODE && this.bookingSteps.length > 4,
            'multi-col2': this.booking_type == TRIP_TYPE_MULTICITY_CODE && this.bookingSteps.length > 2 && this.bookingSteps.length < 5,
        };
    };
    INDRAStepsFooterComponent.prototype.INDRA_getActionBoxClasses = function () {
        return {
            'expanded': !this.showReturn,
            'multi-col3': this.booking_type == TRIP_TYPE_MULTICITY_CODE && this.bookingSteps.length > 4
        };
    };
    INDRAStepsFooterComponent.prototype.INDRA_registerGASelectDates = function () {
        var origin = this.googleAnalytics.IBE_getOriginAirport();
        var dest = this.googleAnalytics.IBE_getDestinationAirport();
        var flightCode = origin.code + "-" + dest.code;
        var flightName = origin.code + "-" + dest.code;
        var eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName);
        eventDataLayerObject.actionField =
            this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);
        this.googleAnalytics.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
    };
    INDRAStepsFooterComponent.prototype.INDRA_getFlightTotalCost = function () {
        if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) {
            var flightTotalPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights);
            return this.INDRA_formatMiles(this.milesInFlightDiscount.miles) + ' + ' + this.INDRA_formatCash(flightTotalPrice - this.milesInFlightDiscount.cash);
        }
        else {
            return this.flightPriceService.INDRA_getSelectedFlightsTotalCost(this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights);
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_formatMiles = function (value) {
        return value.toFixed(0) + ' M';
    };
    INDRAStepsFooterComponent.prototype.INDRA_getTotalPrice = function () {
        var _this = this;
        if (this.bookedTrip && this.bookedTrip.is_time_to_think && this.router.url.indexOf('time-to-think') > 0) {
            var timeToThink = this.bfmStorage.INDRA_getTimeToThink();
            if (timeToThink && timeToThink.totalFee) {
                return timeToThink.totalFee.toFixed(2) + " " + this.currency;
            }
        }
        else {
            if (this.router.url.includes('review-your-trip') ||
                this.router.url.includes('extras-to-your-trip') && this.totalFlightPrice) {
                if (this.promoCodesAndVoucher.length > 0 || this.bookAwardFlights) {
                    var currency = this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit;
                    var miles = this.totalFlightPrice.miles && this.totalFlightPrice.miles > 0 ? this.totalFlightPrice.miles + ' M' : '';
                    var cash = this.totalFlightPrice.cash ? this.totalFlightPrice.cash.toFixed(2) + ' ' + currency : '0.00 ' + currency;
                    return miles ? miles + ' + ' + cash : cash;
                }
                else {
                    var booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
                    var currency = this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit;
                    var miles = this.totalFlightPrice.miles && this.totalFlightPrice.miles > 0 ? this.totalFlightPrice.miles : 0;
                    var cash = this.totalFlightPrice.cash ? this.totalFlightPrice.cash : 0;
                    var milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
                    var initialMilesAllowance = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? -(Number(milesAllowanceConfig)) : -1800;
                    var deficitMiles = this.isUserLoggedIn ? this.userMiles - miles : miles;
                    var milesAllowance = this.bookAwardFlights ? 0 : initialMilesAllowance;
                    if (this.isUserLoggedIn && deficitMiles < milesAllowance) {
                        miles = 0;
                    }
                    else {
                        // Override prices from API if has mgp1 discount AND mgp1 == flight milesgo discount in store (and no promocode/voucher) AND bookingTotal.miles from API is NULL or 0.
                        // Note that we are also considering if there are ancillaries paid with miles (bookingTotal.miles from API is NOT NULL and NOT 0 -- this is the else if below) 
                        // but still does not include the mgp1 miles discount (we are using the condition initialMGDiscount === cashDiscountEquivalentOfMilesDiscount 
                        // to determine that mgp1 is applied in front AND miles - milesInFlightDiscount > 0 to determine that there is ancillaries being paid by miles)
                        var initialMGDiscount = this.bookedTripDiscounts && this.bookedTripDiscounts.length > 0 && this.bookedTripDiscounts[0] && this.bookedTripDiscounts[0].value ?
                            this.bookedTripDiscounts[0].value : 0;
                        var milesInFlightDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.miles ? this.milesInFlightDiscount.miles : 0;
                        var cashDiscountEquivalentOfMilesDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.cash ? this.milesInFlightDiscount.cash : 0;
                        if (miles == 0 && (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
                            miles = milesInFlightDiscount;
                            if (this.userMiles > 0 || this.isUserLoggedIn) {
                                cash = cash - initialMGDiscount;
                            }
                        }
                        else if (miles > 0 && (miles - milesInFlightDiscount) > 0 &&
                            (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
                            miles += milesInFlightDiscount;
                            if (this.userMiles > 0 || this.isUserLoggedIn) {
                                cash = cash - initialMGDiscount;
                            }
                        }
                    }
                    if (miles > 0 && this.userMiles >= 0 && this.isUserLoggedIn) {
                        return miles.toFixed(0) + " M + " + cash.toFixed(2) + " " + currency;
                    }
                    else {
                        return cash.toFixed(2) + " " + currency;
                    }
                }
            }
            else if (this.router.url.includes('/booking/payment')) {
                if (this.promoCodesAndVoucher.length > 0 || this.bookAwardFlights) {
                    var currency = this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit;
                    var miles = this.totalFlightPrice.miles && this.totalFlightPrice.miles > 0 ? this.totalFlightPrice.miles + ' M' : '';
                    var cash = this.totalFlightPrice.cash ? this.totalFlightPrice.cash.toFixed(2) + ' ' + currency : '0.00 ' + currency;
                    return miles ? miles + ' + ' + cash : cash;
                }
                else {
                    var currency = this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit;
                    var miles = this.totalFlightPrice.miles && this.totalFlightPrice.miles > 0 ? this.totalFlightPrice.miles : 0;
                    var cash = this.totalFlightPrice.cash ? this.totalFlightPrice.cash : 0;
                    if (miles > 0) {
                        return miles.toFixed(0) + " M + " + cash.toFixed(2) + " " + currency;
                    }
                    else {
                        return cash.toFixed(2) + " " + currency;
                    }
                }
            }
            else {
                // This is for flights page only
                if (this.bookedTrip && this.bookedTrip.flights.length) {
                    if (this.bookingService.isLastStep() && this.current_page === 'flights' && (this.selectedFlight)) {
                        if (this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE && this.bookAwardFlights && this.selectedFlight.bound === "inbound") {
                            this.outboundPrice = this.flightPriceService.INDRA_getBookingTotalCost(this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, [], [], 0);
                            var award = this.outboundPrice.split(' ');
                            var miles = award[0];
                            var price = award[3];
                            var totalMilesValue = parseFloat(miles) + this.selectedFlight.options.brand.bookAwardValue;
                            var totalPriceValue = parseFloat(price) + this.selectedFlight.options.price + this.selectedFlight.options.tax;
                            return totalMilesValue.toFixed(0) + " M + " + totalPriceValue.toFixed(2) + " " + this.currency;
                        }
                        else if (this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE && !this.bookAwardFlights && this.selectedFlight.bound === "inbound") {
                            var flightsPrice = [
                                this.bookedTrip.flights[0],
                                this.selectedFlight
                            ];
                            if (this.isUserLoggedIn) {
                                this.outboundPrice = this.flightPriceService.INDRA_getBookingTotalCost(flightsPrice, this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, [], [], 0);
                            }
                            else {
                                this.outboundPrice = this.flightPriceService.INDRA_getBookingTotalCost(flightsPrice, this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, [], this.weakFlightsDiscount, [], [], 0);
                            }
                            this.outboundPrice = this.outboundPrice.replace(' ' + this.currency, '');
                            return parseFloat(this.outboundPrice) + ' ' + this.currency;
                            //   const isInbound = this.bookedTrip.flights.find((trip: any) => trip.bound === 'inbound');
                            //   if(isInbound) {
                            //     return parseFloat(this.outboundPrice) + ' ' + this.currency;
                            //   }
                            //   else {
                            //     return parseFloat(this.outboundPrice) + this.selectedFlight.options.price + ' ' + this.currency;
                            //   }
                        }
                        else {
                            var discounts = this.bookedTripDiscounts.map(function (discount) {
                                // For m&g discount, divide the amount by 2 for round trip flights, this logic is from flight-result.indra.component.ts -> INDRA_finalPrice()
                                if (_this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE && discount.id === 'mile-go') {
                                    var newDiscount = __assign({}, discount);
                                    newDiscount.value = discount.value / 2;
                                    discount = newDiscount;
                                }
                                return discount;
                            });
                            if (this.isUserLoggedIn) {
                                return this.outboundPrice = this.flightPriceService.INDRA_getBookingTotalCost([this.selectedFlight], this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, discounts, this.weakFlightsDiscount, [], [], 0);
                            }
                            else {
                                return this.outboundPrice = this.flightPriceService.INDRA_getBookingTotalCost([this.selectedFlight], this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, [], this.weakFlightsDiscount, [], [], 0);
                            }
                        }
                    }
                    else {
                        // this computation should only be for availability pages
                        if (this.selectedMultiFlights) {
                            if (this.bookAwardFlights) {
                                var totalPrice = this.selectedMultiFlights.reduce(function (acc, flight) {
                                    var miles = (acc.miles || 0) + (flight.options.price || 0);
                                    var price = (acc.price || 0) + ((flight.options.obFee || 0) + (flight.options.tax || 0));
                                    return { miles: miles, price: price };
                                }, { miles: 0, price: 0 } // Proper initial value for accumulator
                                );
                                return totalPrice.miles + " M + " + totalPrice.price.toFixed(2) + " " + this.currency;
                            }
                            else {
                                if (this.isUserLoggedIn) {
                                    return this.selectedMultiFlights.totalPrice.toFixed(2) - this.discountMiles + " " + this.currency;
                                }
                                else {
                                    return this.selectedMultiFlights.totalPrice.toFixed(2) + " " + this.currency;
                                }
                            }
                        }
                        var discounts = this.bookedTripDiscounts.map(function (discount) {
                            // For m&g discount, divide the amount by 2 for round trip flights, this logic is from flight-result.indra.component.ts -> INDRA_finalPrice()
                            if (_this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE && discount.id === 'mile-go') {
                                var newDiscount = __assign({}, discount);
                                newDiscount.value = discount.value / 2;
                                discount = newDiscount;
                            }
                            return discount;
                        });
                        return this.flightPriceService.INDRA_getBookingTotalCost(this.bookedTrip.flights, this.bookedTrip.booking_type, this.bookAwardFlights, false, this.promoCodesAndVoucher, discounts, this.weakFlightsDiscount, [], [], 0);
                    }
                }
                else {
                    // Logic from flight-result.indra.component.ts -> INDRA_finalPrice()
                    var discountMiles = this.booking_type === TRIP_TYPE_ROUND_TRIP_CODE
                        ? this.discountMiles / 2
                        : this.discountMiles;
                    if (this.selectedFlight) {
                        if (this.bookAwardFlights) {
                            return this.selectedFlight.options.brand.bookAwardValue.toFixed(0) + " M + " + this.selectedFlight.options.tax.toFixed(2) + " " + this.currency;
                        }
                        else {
                            if (this.isUserLoggedIn) {
                                return this.selectedFlight.options.price.toFixed(2) - discountMiles + " " + this.currency;
                            }
                            else {
                                return this.selectedFlight.options.price.toFixed(2) + " " + this.currency;
                            }
                        }
                    }
                    else if (this.selectedMultiFlights) {
                        if (this.bookAwardFlights) {
                            var totalPrice = this.selectedMultiFlights.reduce(function (acc, flight) {
                                var miles = (acc.miles || 0) + (flight.options.price || 0);
                                var price = (acc.price || 0) + ((flight.options.obFee || 0) + (flight.options.tax || 0));
                                return { miles: miles, price: price };
                            }, { miles: 0, price: 0 } // Proper initial value for accumulator
                            );
                            return totalPrice.miles + " M + " + totalPrice.price.toFixed(2) + " " + this.currency;
                        }
                        else {
                            if (this.isUserLoggedIn) {
                                return this.selectedMultiFlights.totalPrice.toFixed(2) - discountMiles + " " + this.currency;
                            }
                            else {
                                return this.selectedMultiFlights.totalPrice.toFixed(2) + " " + this.currency;
                            }
                        }
                    }
                    else if (this.selectedStopoverFlights) {
                        if (this.bookAwardFlights)
                            return this.selectedFlight.options.brand.bookAwardValue.toFixed(0) + " M + " + this.selectedFlight.options.tax.toFixed(2) + " " + this.currency;
                        else {
                            if (this.isUserLoggedIn) {
                                return this.selectedStopoverFlights.totalPrice.toFixed(2) - discountMiles + " " + this.currency;
                            }
                            else {
                                return this.selectedStopoverFlights.totalPrice.toFixed(2) + " " + this.currency;
                            }
                        }
                    }
                    else {
                        return this.bookAwardFlights ? '0 M + 0.00 ' + this.currency : '0.00 ' + this.currency;
                    }
                }
            }
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_updateBookingTotals = function () {
        var _this = this;
        // call generate API in order to get the updated booking total price to pay
        this.paymentService.setUpdateBookingTotals(false);
        var generateTemporaryPNR = this.bookingSearchService.INDRA_generateTemporaryPNR()
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (response) {
            if (response && response.data && response.data.fare && response.data.fare.bookingTotal) {
                var totalPrice = {
                    cash: response.data.fare.bookingTotal.amount,
                    miles: response.data.fare.bookingTotal.miles,
                    currency: response.data.fare.bookingTotal.currency
                };
                _this.paymentService.setTotalFlightPrice(totalPrice);
            }
        });
        this.allSubs.push(generateTemporaryPNR);
    };
    INDRAStepsFooterComponent.prototype.INDRA_callBookingFare = function (flights) {
        var _this = this;
        if (flights && flights.length > 0) {
            // returns array of idOffers of oubound flights
            var idOffers = flights.map(function (data) {
                return data.options.idOffer;
            });
            var idOffersList = idOffers && idOffers.length > 0 ? idOffers.slice(0, 1) : [];
            // returns array of outbound idFlight
            var listIdOutboundArray = flights.map(function (data) {
                return data['idFlight'];
            });
            // call bookingFare API
            var params = {
                listIdOutbound: listIdOutboundArray,
                idInbound: 0,
                idOffer: idOffersList,
                fareFamilyOutwardCod: null,
                fareFamilyReturnCod: null,
                listRBDOutbound: null,
                rbdInbound: null,
                forPoints: this.bookAwardFlights
            };
            this.bookingFareSubscription = this.bookingSearchService.INDRA_postBookingFare(params).subscribe(function (response) {
                if (response && response.data && response.errors.length == 0) {
                    _this.INDRA_registerGASelectFlight(flights);
                    var milesDiscountInCash = _this.bookedTripDiscounts.filter(function (discount) { return discount.id == "mile-go"; }).length ? _this.bookedTripDiscounts.filter(function (discount) { return discount.id == "mile-go"; })[0].value : 0;
                    if (milesDiscountInCash > 0) {
                        _this.milesService.INDRA_updateMiles(_this.bookedTripDiscounts[0].value).subscribe(function (result) {
                            _this.router.navigateByUrl('/booking/review-your-trip');
                        });
                    }
                    else {
                        _this.router.navigateByUrl('/booking/review-your-trip');
                    }
                }
                else {
                    _this.selectPack.emit({ selectPack: false, response: response }); // return false to show message
                }
            }, function (error) {
                // TODO show error message when this fails
            });
            this.allSubscriptions.push(this.bookingFareSubscription);
        }
    };
    INDRAStepsFooterComponent.prototype.INDRA_registerGASelectFlight = function (flights) {
        var isEcommerce = true;
        var origin = this.googleAnalytics.IBE_getOriginAirport(null, isEcommerce);
        var dest = this.googleAnalytics.IBE_getDestinationAirport(null, null, isEcommerce);
        var flightCode = origin + "-" + dest;
        var flightName = origin + "-" + dest;
        var price = flights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.price; }, 0);
        var tax = flights.filter(function (cur) { return cur.options; }).reduce(function (acc, cur) { return acc += cur.options.tax + cur.options.obFee; }, 0);
        var cashPrice = this.bookAwardFlights ? parseFloat(tax).toFixed(2) : parseFloat(price).toFixed(2);
        var milesPrice = this.bookAwardFlights ? price : 0;
        var eventDataLayerObject = this.googleAnalytics.IBE_createGA_FlightProducts(flightCode, flightName, undefined, undefined, cashPrice);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
        this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRAStepsFooterComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAStepsFooterComponent.prototype.INDRA_isSelectingRoundtripDeparture = function () {
        if (this.booking_type == TRIP_TYPE_ROUND_TRIP_CODE && this.bookedTrip.flights.length === 0 && !this.is_stopover && this.current_page === 'flights') {
            return true;
        }
        return false;
    };
    INDRAStepsFooterComponent.prototype.INDRA_loadTranslations = function () {
        var _this = this;
        var language = sessionStorage.getItem('language');
        if (language) {
            this.ibeAdminService.loadTranslations('tap', ['footer'], language);
            setTimeout(function () {
                _this.btnText = _this.INDRA_getTranslation('footer.text.continueToPayment');
                _this.passengers_label = _this.bookedTrip.passengerCount.toString() + ' ' + _this.INDRA_getTranslation('footer.text.passengers');
            }, 1000);
        }
    };
    return INDRAStepsFooterComponent;
}());
export { INDRAStepsFooterComponent };
